<template>
  <v-select
    :value="value"
    dense
    outlined
    :hide-details="hideDetails"
    class="rmr-input"
    :class="{ 'rmr-input--md': size === 'md', 'rmr-input--no-chips': noChips }"
    v-bind="fieldAttrs"
    v-on="listeners"
  />
</template>

<script>
import { rmrChoiceFieldComputed } from "./build-rmr-choice-field-attrs";

export default {
  name: "RmrSelect",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: null,
    },
    noChips: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "sm",
      validator: (v) => ["sm", "md"].includes(v),
    },
    hideDetails: {
      type: [Boolean, String],
      default: true,
    },
  },
  computed: rmrChoiceFieldComputed,
};
</script>

<style lang="scss" scoped>
@import "./_rmr-input.scss";
</style>
